// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__veAvQ","avatar":"Message_avatar__f-GGq","textWrapper":"Message_textWrapper__Fh13+","text":"Message_text__lZcQf","author":"Message_author__4H77z"};